// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1vZ0K","icon":"SortAdornment_icon__1_j_Y","up":"SortAdornment_up__1amNl","down":"SortAdornment_down__1aOkr","active":"SortAdornment_active__bF8b_"};